import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  getRenterQualificationByTenantScreeningCriteria,
} from 'common/householdApplication/prequalificationHelpers';

import analytics from 'client/analytics';
import {
  ANALYTICS_EVENT_PREQUAL_COMPLETED_REQUEST_TOUR_PROMPT_WITH_LISTING_IMAGE,
  ANALYTICS_EVENT_PREQUAL_COMPLETED_REQUEST_TOUR_PROMPT_OPT_OUT,
} from 'client/analytics/eventList';

import {
  SCREEN_ID_PREQUAL_COMPLETED_REQUEST_TOUR,
} from 'client/constants/screenIds';

import {
  LISTING_DATA_SOURCE_SUNROOM,
} from 'common/listingConstants';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';

import Navbar from 'client/components/Navbar';
import SrLink from 'client/components/SrLink/SrLink';
import SrRequestShowingButton from 'client/components/SrRequestShowingButton';
import SrListingQualificationsCard from 'client/components/SrListingQualificationsCard';
import SrBatteryMessage from 'client/components/SrBatteryMessage';

import ListingActions from 'client/actions/Listing';
import HouseholdActions from 'client/actions/Household';
import NavigatorActions from 'client/actions/Navigator';
import TenantScreeningCriteriaActions from 'client/actions/TenantScreeningCriteria';
import branch from 'client/core/branch';

import {
  getListingManagedPhotoUrls,
} from 'common/listingHelpers';

@withTransitionHook
@withScreenId(SCREEN_ID_PREQUAL_COMPLETED_REQUEST_TOUR)
@branch({
  currentUserId: ['currentUser', 'id'],
  listing: ['listing'],
  renterProfilesByUserId: ['household', 'renterProfilesByUserId'],
  tenantScreeningCriteriaByPartner: ['tenantScreeningCriteriaByPartner'],
})
@withScrollToTop
class PrequalCompletedRequestTour extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'You\'re Qualified  | Sunroom Rentals',
  })

  static propTypes = {
    currentUserId: PropTypes.number.isRequired,
    renterProfilesByUserId: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    tenantScreeningCriteriaByPartner: PropTypes.object.isRequired,
  }

  static fetchData(match, inject) {
    const currentUserId = inject.state.get(['currentUser', 'id']);
    const listingId = match.params.listingId;
    return Promise.all([
      ListingActions.getById(inject, listingId),
      HouseholdActions.loadRenterProfile(inject, { userId: currentUserId }),
    ]).then(([listing]) => {
      if (listing && listing.dataSource === LISTING_DATA_SOURCE_SUNROOM && listing.listingManagementCompany) {
        return TenantScreeningCriteriaActions.getTenantScreeningCriteria(inject, {
          managementCompanyName: listing.listingManagementCompany,
        });
      }
    });
  }

  _onRequestTourButtonClick = () => {
    analytics.track(ANALYTICS_EVENT_PREQUAL_COMPLETED_REQUEST_TOUR_PROMPT_WITH_LISTING_IMAGE);
  }

  _onOptOutLinkClick = () => {
    const { dispatch } = this.props;
    analytics.track(ANALYTICS_EVENT_PREQUAL_COMPLETED_REQUEST_TOUR_PROMPT_OPT_OUT);
    dispatch(NavigatorActions.clearPathHistory);
  }

  render() {
    const {
      currentUserId,
      listing,
      renterProfilesByUserId,
      tenantScreeningCriteriaByPartner,
    } = this.props;
    const renterProfile = renterProfilesByUserId && renterProfilesByUserId[currentUserId] || null;
    const tenantScreeningCriteria = (
      (listing && tenantScreeningCriteriaByPartner[listing.listingManagementCompany])
      || null
    );

    if (!listing) {
      return null;
    }

    const managedPhotoUrls = getListingManagedPhotoUrls({
      listing: listing,
    });

    let qualificationsDOM = null;

    if (tenantScreeningCriteria) {
      const { requirements } = getRenterQualificationByTenantScreeningCriteria({
        listing,
        tenantScreeningCriteria,
        householdApplication: renterProfile || {},
      });

      qualificationsDOM = (
        <div className='qualificationsCard'>
          <div className='textContainer'>
            {requirements.map((requirement) => (
              <div key={requirement.title} className='qualificationRow'>
                <SrBatteryMessage
                  message={requirement.title}
                  isNegative={!requirement.isQualified}
                />
              </div>
            ))}
          </div>
        </div>
      );
    }
    else {
      qualificationsDOM = (
        <SrListingQualificationsCard
          renterProfile={renterProfile}
          listing={listing}
        />
      );
    }

    const contentContainerWithImage = (
      <div className='contentContainer withImage'>
        <div
          className='listingImageContainer'
          style={{
            backgroundImage: `url("${managedPhotoUrls[0]}")`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            height: '230px',
            width: '100%',
          }}
        >
          <div className='imageContent'>
            <span className='badge-xs' />
            <span className='content'>
              You are qualified to rent this home now!
            </span>
          </div>
        </div>

        <div className='qualificationsCardContainer'>
          {qualificationsDOM}
        </div>
      </div>
    );

    return (
      <div className='page-prequal-request-tour'>
        <Navbar disableRedirect />
        {contentContainerWithImage}
        <div className='ctaContainer'>
          <SrRequestShowingButton
            listing={listing}
            buttonTextOverride='request tour now'
            onClick={this._onRequestTourButtonClick}
          />
          <SrLink
            to={`/listing/${listing.id}?scrollTo=yourQualifications`}
            className='optOut'
            onClick={this._onOptOutLinkClick}
          >
            I don’t want to request a tour yet
          </SrLink>
        </div>
      </div>
    );
  }
}

PrequalCompletedRequestTour.displayName = 'PrequalCompletedRequestTour';

export default PrequalCompletedRequestTour;
